import PersonalInfo from '../../components/Cards/PersonalInfo';
import PhoneHelp from '../../components/Cards/PhoneHelp';
import Contract from '../../components/Cards/Contract';
import { useTrainings } from '../../hooks/Training';
import ContractCfa from '../../components/Cards/ContractCfa';
import BLoader from '../../components/BLoader';
import { useHeader } from '../../context/HeaderContext';
import { useEffect } from 'react';

const DashboardHome = () => {
  const { setTitle, setDescription } = useHeader();
  useEffect(() => {
    setTitle('');
    setDescription('');
  }, [setDescription, setTitle]);
  const { data: trainings, isSuccess: training_isSuccess, isFetching: training_isFetching } = useTrainings();
  if (training_isFetching) {
    return <BLoader />;
  }
  if (!training_isSuccess) {
    return;
  }
  return (
    <div className={`flex flex-col gap-6 lg:flex-row`}>
      <div className={'flex w-full flex-col gap-4 lg:flex-row'}>
        {trainings.length > 0 &&
          trainings.map((training) => {
            if (training?.contract?.financedType?.type === 'cfa') return <ContractCfa training={training} />;
            return <Contract training={training} />;
          })}
      </div>
      <div className={'flex flex-col gap-6'}>
        <PersonalInfo />
        <PhoneHelp />
      </div>
    </div>
  );
};

export default DashboardHome;
